import * as S from './PageShape.styled'

export const PageShape = ({ itemRef, ...props }) => (
  <S.Shape ref={itemRef} {...props} />
)

export default PageShape
